export { productsApi as api } from 'adapters';
